<template>
  <div class="case-kalendar section">
    <div class="kalendar-dropdown">
      <img class="calendar-icon" src="@/assets/img/kalendar.svg" />
      <div class="mini-calendar-title">Kalendar</div>
    </div>
    <div
      v-if="$route.name == 'Case' && is_a_moron"
      class="add-event add-button add-plus"
      @click="$router.push('kalendar/novi-dogadaj')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
      >
        <g>
          <g>
            <path
              fill="#0acab1"
              d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="case-minikalendar-wrapper" v-if="is_a_moron">
      <div class="kalendar-broj-dogadanja">
        Imate <span>{{ rasporedi_liste[2].length }}</span> događanja ovaj mjesec
      </div>
      <div class="kalendar-mjesec">{{ getMonth() }} {{ getYear() }}</div>
      <div class="kalendar-img">
        <div class="opening-folder kalendar-wrapper">
          <div class="kalendar">
            <div class="minikalendar-day-grid">
              <div class="minikalendar-day">Pon</div>
              <div class="minikalendar-day">Uto</div>
              <div class="minikalendar-day">Sri</div>
              <div class="minikalendar-day">Čet</div>
              <div class="minikalendar-day">Pet</div>
              <div class="minikalendar-day">Sub</div>
              <div class="minikalendar-day sunday">Ned</div>
            </div>
            <div class="minikalendar-day-grid weekdays">
              <div v-if="fetching" class="center-spinner">
                <svg class="dot-spin" viewBox="0 0 50 50">
                  <circle
                    class="path"
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke-width="5"
                  ></circle>
                </svg>
              </div>
              <div
                v-else
                v-for="(dan, key) in raspon_datuma"
                :key="key"
                :class="dan.classes"
                @click="updateClickedClass(key)"
              >
                {{ dan.dan_enum }}
                <div class="today-events-mini">
                  <div
                    v-for="(added_class, key) in dan.added_classes.slice(0,4)"
                    :key="key"
                    :class="'dot d-' + added_class"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kalendar-sve pogledaj-sve" @click="goToPredmet('kalendar')">
        kompletan kalendar
      </div>
    </div>
    <div class="case-kalendar-event"  :key="updateView">
      <!-- <div class="section-title">Događaji</div> -->
      <MiniEvent :events_list="finalni_arr_prikaza" ref="eventovi" />
      <div
        v-if="rasporedi_liste[0].length == 0"
        class="case-kalendar-event-empty"
      >
        Nemate događaja na odabrani dan
      </div>
      <div
        v-if="rasporedi_liste[0].length != 0 && all_pages.length > 1"
        class="cases-pagination-left"
      >
        <div class="pagin-wrapp page-nav">
          <div class="page-nav-prev" v-if="!isFirstPage" @click="setPage(curr_page - 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1018">
                  <path
                    d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1018")'></path>
                  </g>
                  <g>
                    <g>
                      <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="page-nav-no">
            <div :class="{ 'curr-page': curr_page == 1 }" @click="setPage(1)">
              1
            </div>
          </div>
          <div class="page-nav-no" v-if="left_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-for="(str, key) in getLeftRightPages" :key="key" @click="setPage(str)">
            <div :class="{ 'curr-page': curr_page == str }">
              {{ str }}
            </div>
          </div>
          <div class="page-nav-no" v-if="right_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-if="all_pages.length>1">
          <div :class="{ 'curr-page': curr_page == all_pages.length }"
            @click="setPage(all_pages.length)">
            {{ all_pages.length }}
          </div>
          </div>
          <div class="page-nav-next" v-if="!isLastPage" @click="setPage(curr_page + 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1043">
                  <path
                    d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1043")'></path>
                  </g>
                  <g>
                    <g>
                      >
                      <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import auth from "@/services/auth";
import person from "@/apiCallers/person";
import ms_calendar from "@/apiCallers/calendarSharepoint";
import CalendarCreateEdit from "@/components/caseComponents/CalendarCreateEdit.vue";
import MiniEvent from "@/components/calendarComponents/MiniEvent.vue";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import gsap from "gsap";
import permissioner from "../../services/permissioner";

export default {
  props:{
    is_a_moron : {
      typeof : Boolean,
      default : true
    }
  },
  components: { CalendarCreateEdit, MiniEvent },
  data: function () {
    return {
      //CURRENT CASE DATA BEGIN
      predmet_info: null,
      fiz_stranke: null,
      prav_protustranke: null,
      rootSpisi: [],
      // CURRENT CASE DATA END

      selected_month: moment().month(),
      accessToken: "",
      //dnevni - idx0, tjedni - idx1, mjesecni - idx2,
      rasporedi_liste: [[], [], []],
      selected_year: moment().year(),
      current_day: moment().date(),
      raspon_datuma: [],
      mjeseci: {
        1: "Siječanj",
        2: "Veljača",
        3: "Ožujak",
        4: "Travanj",
        5: "Svibanj",
        6: "Lipanj",
        7: "Srpanj",
        8: "Kolovoz",
        9: "Rujan",
        10: "Listopad",
        11: "Studeni",
        12: "Prosinac",
      },
      kategorija_liste: 1,
      categories: [
        { name: "Važno", class: "d-red" },
        { name: "Osobno", class: "d-grey" },
        { name: "Predmet", class: "d-green" },
        { name: "PSOD", class: "d-red" },
      ],
      curr_page: 1,
      br_redova: 2,
      all_pages: [],
      finalni_arr_prikaza: [],
      fetching: true,
      sioVar: {
        type: {},
        required: false,
        default: null,
      },
      updateView:0,
      left_dots_visible: false,
      right_dots_visible: false,
    };
  },
  watch: {
    selected_month: function () {
      this.updateRasponDatuma();
      this.kategorija_liste = 1;
    },
    curr_page: function () {
      this.paginirajOdabrane();
      // this.rasporedi_liste = [[],[],[]];
    },
    sioVar: function (){
      if (this.sioVar != null) {
        this.sioVar.socket.on("update task", async () => {
          this.finalni_arr_prikaza = [];
          await this.updateRasponDatuma();
          this.updateClickedClass(this.current_day);
        });
      }
    },
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    await this.updateRasponDatuma();
    this.sioVar = this.$store.state.sioVar
    
    let first_day = this.raspon_datuma.findIndex((obj) => obj.dan_enum == 1);
    this.current_day = first_day + moment().date() - 1;
    if (this.$route.params.uid != undefined) {
      await permissioner.checkUserInfo();

        let all_together = this.$store.state.current_selected_case

        this.predmet_info = all_together;
        this.fiz_stranke = all_together.connect_fiz_stranka;
        this.prav_protustranke = all_together.prav_connect_protustranka;
        this.rootSpisi = all_together.spis;
    }

    this.updateClickedClass(this.current_day);
    console.log(this.rasporedi_liste);
  },
  methods: {
    cleanClasses() {
      this.raspon_datuma.forEach((dan) => {
        dan.classes = dan.classes.replace("week", "");
        dan.classes = dan.classes.replace("today", "");
      });
    },

    //nedjelja je nula
    //ponedjeljak ima vrijednost 1
    updateClickedClass(list_idx) {
      //CLEAN values for day and week
      this.rasporedi_liste[0] = [];
      this.rasporedi_liste[1] = [];

      //Očisti sve klase
      this.cleanClasses();
      this.raspon_datuma[list_idx].classes =
        this.raspon_datuma[list_idx].classes + " today";
      moment.locale("hr");
      let clicked_day = parseInt(
        moment(this.raspon_datuma[list_idx].fullDate).day()
      );

      // console.log("clicked day " + clicked_day);
      var end_idx = 0;
      var start_idx = 0;
      var kvocijent = Math.floor(list_idx / 7);
      // console.log(kvocijent);
      start_idx = kvocijent * 7;
      end_idx = start_idx + 6;
      this.getDayEventList(list_idx);
      this.getMonthEventList(start_idx, end_idx);

      this.kategorija_liste = 1;
      this.calculatePageNumber();
      this.paginirajOdabrane();
    },
    async updateRasponDatuma() {
      this.fetching = true;
      (this.rasporedi_liste = [[], [], []]), (this.raspon_datuma = []);
      if (this.$route.name == "Case") {
        await ms_calendar
          .getMiniCallendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            this.$route.params.uid
          )
          .then((resp) => {
            // console.log(resp.data);
            this.fetching = false;
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
          });
      } else {
        let lawyer_id = await person.getSelf(this.accessToken);
        lawyer_id = lawyer_id.data.uid;

        await ms_calendar
          .getPersonMiniCalendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            lawyer_id
          )
          .then((resp) => {
            this.fetching = false;
            // console.log(resp.data);
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
          });
      }
    },

    //update list of selected day events START

    getDayEventList(day_idx) {
      this.rasporedi_liste[0] = this.raspon_datuma[day_idx].date_events;
    },
    getMonth() {
      return this.mjeseci[moment().month() + 1];
    },
    getYear() {
      return moment().year();
    },
    getMonthEventList(strt_d, end_d) {
      for (var i = strt_d; i <= end_d; i++) {
        this.rasporedi_liste[1] = this.rasporedi_liste[1].concat(
          this.raspon_datuma[i].date_events
        );
      }
    },
    calculatePageNumber() {
      this.all_pages = [];
      var finalni_broj = this.rasporedi_liste[0].length / this.br_redova;
      if (this.rasporedi_liste[0].length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages.push(i);
      }
      if (this.all_pages.length != 0) {
        this.curr_page = 1;
      }
    },
    paginirajOdabrane() {
      let start_idx = 0 + this.br_redova * (this.curr_page - 1);
      let end_idx = this.br_redova * this.curr_page;

      this.finalni_arr_prikaza = this.rasporedi_liste[0].slice(
        start_idx,
        end_idx
      );
    },
    setPage(pg) {
      this.curr_page = pg;
    },
    goToPredmet(nastavak) {
      this.$router.push(nastavak);
    },
  },
  computed: {
    computed_date() {
      let date_arr = this.chosen_date.split("-");
      return this.mjeseci[parseInt(date_arr[1] - 1)] + ", " + date_arr[0] + ".";
    },
    isFirstPage() {
      return this.curr_page == 1;
    },
    isLastPage() {
      return this.curr_page == this.all_pages[this.all_pages.length - 1];
    },
    getLeftRightPages() {
      // Init values
      let return_pages = []
      this.right_dots_visible = false;
      this.left_dots_visible = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page;
      if(this.curr_page == this.all_pages.length)
        left_end = this.curr_page-1;
      if (this.curr_page > 3) {
        left_start = this.curr_page - 1;
        this.left_dots_visible = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page + 1;
      if (right_start < this.all_pages.length)
        return_pages.push(right_start);
      if(right_start < this.all_pages.length-1)
      this.right_dots_visible = true;
      return return_pages
    },
  },
  destroyed() {
    gsap.to(".router-wrapper", 0.5, {
      filter: "none",
      opacity: 1,
    });
    this.$store.state.event_details.popup_open = false;
  },
};
</script>

<style></style>